<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <div class="main px-xl-5 px-lg-4 px-3">
    <!-- Body -->
    <div class="main-body">
      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">
          <div class="row align-items-center">
            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Card's </h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">
          <!-- Doc: Introduction -->
          <div class="row">
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Examples</h5>
              <p>Cards are built with as little markup and styles as possible, but still manage to deliver a ton of
                control and customization. Built with flexbox, they offer easy alignment and mix well with other
                Bootstrap
                components. They have no <code class="text-danger">margin</code> by default, so use <a
                  href="https://getbootstrap.com/docs/4.5/utilities/spacing/">spacing utilities</a> as needed.
              </p>
              <p>Below is an example of a basic card with mixed content and a fixed width. Cards have no fixed width to
                start, so they’ll naturally fill the full width of its parent element. This is easily customized with
                our
                various <a href="#sizing">sizing options</a>.
              </p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                      [ngClass]="{'active': viewTab}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                      [ngClass]="{'active': codeTab}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c1" [ngClass]="{'show active': viewTab}">
                      <div class="row">
                        <div class="col-lg-4 col-md-6">
                          <div class="card">
                            <img src="assets/images/gallery/1.jpg" class="card-img-top" alt="...">
                            <div class="card-body">
                              <h5 class="card-title">Card title</h5>
                              <p class="card-text">Some quick example text to build on the card title and make up the
                                bulk
                                of the card's content.
                              </p>
                              <a href="#" class="btn btn-primary">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                          <div class="card shadow-sm border-0">
                            <img src="assets/images/gallery/2.jpg" class="card-img-top" alt="...">
                            <div class="card-body">
                              <h5 class="card-title">Card title</h5>
                              <p class="card-text">Some quick example text to build on the card title and make up the
                                bulk
                                of the card's content.
                              </p>
                              <a href="#" class="btn btn-secondary">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-1" [ngClass]="{'show active': codeTab}">
                      <pre><code class="language-html">&lt;div class=&quot;card&quot;&gt;
      &lt;img src=&quot;assets/images/gallery/1.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;Some quick example text to build on the card title and make up the bulk of the card's content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;div class=&quot;card shadow-sm border-0&quot;&gt;
      &lt;img src=&quot;assets/images/gallery/2.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;Some quick example text to build on the card title and make up the bulk of the card's content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-secondary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Titles, text, and links</h5>
              <p>Card titles are used by adding <code class="text-danger">.card-title</code> to a <code
                  class="text-danger">&lt;h*&gt;</code> tag. In the same way, links are added and placed next to each
                other by adding <code class="text-danger">.card-link</code> to an <code
                  class="text-danger">&lt;a&gt;</code> tag.
              </p>
              <p>Subtitles are used by adding a <code class="text-danger">.card-subtitle</code> to a <code
                  class="text-danger">&lt;h*&gt;</code> tag. If the <code class="text-danger">.card-title</code> and the
                <code class="text-danger">.card-subtitle</code> items are placed in a <code
                  class="text-danger">.card-body</code> item, the card title and subtitle are aligned nicely.
              </p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab2('1')"
                      [ngClass]="{'active': viewTab1}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab2('2')"
                      [ngClass]="{'active': codeTab1}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c2" [ngClass]="{'show active': viewTab1}">
                      <div class="card" style="width: 18rem;">
                        <div class="card-body">
                          <h5 class="card-title">Card title</h5>
                          <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>
                          <p class="card-text">Some quick example text to build on the card title and make up the bulk
                            of the card's content.
                          </p>
                          <a href="#" class="card-link">Card link</a>
                          <a href="#" class="card-link">Another link</a>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-2" [ngClass]="{'show active': codeTab1}">
                      <pre><code class="language-html">&lt;div class=&quot;card&quot;&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
          &lt;h6 class=&quot;card-subtitle mb-2 text-muted&quot;&gt;Card subtitle&lt;/h6&gt;
          &lt;p class=&quot;card-text&quot;&gt;Some quick example text to build on the card title and make up the bulk of the card's content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;card-link&quot;&gt;Card link&lt;/a&gt;
          &lt;a href=&quot;#&quot; class=&quot;card-link&quot;&gt;Another link&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Images, List groups and Kitchen sink</h5>
              <p><code class="text-danger">.card-img-top</code> places an image to the top of the card. With <code
                  class="text-danger">.card-text</code>, text can be added to the card. Text within <code
                  class="text-danger">.card-text</code> can also be styled with the standard HTML tags.</p>
              <p>Mix and match multiple content types to create the card you need, or throw everything in there. Shown
                below are image styles, blocks, text styles, and a list group—all wrapped in a fixed-width card.
              </p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab3('1')"
                      [ngClass]="{'active': viewTab2}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab3('2')"
                      [ngClass]="{'active': codeTab2}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c4" [ngClass]="{'show active': viewTab2}">
                      <div class="row">
                        <div class="col-lg-4 col-md-12">
                          <div class="card">
                            <img src="assets/images/gallery/14.jpg" class="card-img-top" alt="...">
                            <div class="card-body">
                              <p class="card-text">Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12">
                          <div class="card mb-4">
                            <ul class="list-group custom list-group-flush">
                              <li class="list-group-item">Cras justo odio</li>
                              <li class="list-group-item">Dapibus ac facilisis in</li>
                              <li class="list-group-item">Vestibulum at eros</li>
                            </ul>
                          </div>
                          <div class="card shadow-sm border-0">
                            <div class="card-header">
                              Featured
                            </div>
                            <ul class="list-group custom list-group-flush">
                              <li class="list-group-item">Cras justo odio</li>
                              <li class="list-group-item">Dapibus ac facilisis in</li>
                              <li class="list-group-item">Vestibulum at eros</li>
                            </ul>
                            <div class="card-footer">
                              Card footer
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12">
                          <div class="card">
                            <img src="assets/images/gallery/4.jpg" class="card-img-top" alt="...">
                            <div class="card-body">
                              <h5 class="card-title">Card title</h5>
                              <p class="card-text">Some quick example text to build on the card title and make up the
                                bulk of the card's content.
                              </p>
                            </div>
                            <ul class="list-group custom list-group-flush">
                              <li class="list-group-item">Cras justo odio</li>
                              <li class="list-group-item">Vestibulum at eros</li>
                            </ul>
                            <div class="card-body">
                              <a href="#" class="card-link">Card link</a>
                              <a href="#" class="card-link">Another link</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-4" [ngClass]="{'show active': codeTab2}">
                      <pre><code class="language-html">&lt;div class=&quot;card&quot;&gt;
      &lt;img src=&quot;assets/images/gallery/14.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;p class=&quot;card-text&quot;&gt;Some quick example text to build on the card title and make up the bulk of the card's content.&lt;/p&gt;
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;div class=&quot;card mb-4&quot;&gt;
      &lt;ul class=&quot;list-group custom list-group-flush&quot;&gt;
          &lt;li class=&quot;list-group-item&quot;&gt;Cras justo odio&lt;/li&gt;
          &lt;li class=&quot;list-group-item&quot;&gt;Dapibus ac facilisis in&lt;/li&gt;
          &lt;li class=&quot;list-group-item&quot;&gt;Vestibulum at eros&lt;/li&gt;
      &lt;/ul&gt;
  &lt;/div&gt;

  &lt;div class=&quot;card&quot;&gt;
      &lt;img src=&quot;assets/images/gallery/4.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;Some quick example text to build on the card title and make up the bulk of the card's content.&lt;/p&gt;
      &lt;/div&gt;
      &lt;ul class=&quot;list-group custom list-group-flush&quot;&gt;
          &lt;li class=&quot;list-group-item&quot;&gt;Cras justo odio&lt;/li&gt;
          &lt;li class=&quot;list-group-item&quot;&gt;Vestibulum at eros&lt;/li&gt;
      &lt;/ul&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;a href=&quot;#&quot; class=&quot;card-link&quot;&gt;Card link&lt;/a&gt;
          &lt;a href=&quot;#&quot; class=&quot;card-link&quot;&gt;Another link&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Header and footer</h5>
              <p>Add an optional header and/or footer within a card.</p>
              <p>Card headers can be styled by adding <code class="text-danger">.card-header</code> to <code
                  class="text-danger">&lt;h*&gt;</code> elements.</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab4('1')"
                      [ngClass]="{'active': viewTab3}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab4('2')"
                      [ngClass]="{'active': codeTab3}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c3" [ngClass]="{'show active': viewTab3}">
                      <div class="row">
                        <div class="col-lg-4 col-md-12 mb-4">
                          <div class="card border-primary">
                            <div class="card-header bg-primary text-light">
                              Card header
                            </div>
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-primary">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12 mb-4">
                          <div class="card">
                            <h5 class="card-header">Featured</h5>
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-primary">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12 mb-4">
                          <div class="card">
                            <div class="card-header">
                              Quote
                            </div>
                            <div class="card-body">
                              <blockquote class="blockquote mb-0 ps-3">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.
                                </p>
                                <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source
                                    Title</cite>
                                </footer>
                              </blockquote>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mb-4">
                          <div class="card">
                            <div class="card-header">
                              Featured
                            </div>
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-primary">Go somewhere</a>
                            </div>
                            <div class="card-footer text-muted">
                              2 days ago
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mb-4">
                          <div class="card text-center border-primary">
                            <div class="card-header">
                              Featured
                            </div>
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-secondary">Go somewhere</a>
                            </div>
                            <div class="card-footer bg-primary text-light">
                              2 days ago
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-3" [ngClass]="{'show active': codeTab3}">
                      <pre><code class="language-html">&lt;!-- Card: 1 --&gt;
  &lt;div class=&quot;card border-primary&quot;&gt;
      &lt;div class=&quot;card-header bg-primary text-light&quot;&gt;
          Card header
      &lt;/div&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;!-- Card: 2 --&gt;
  &lt;div class=&quot;card&quot;&gt;
      &lt;h5 class=&quot;card-header&quot;&gt;Featured&lt;/h5&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;!-- Card: 3 --&gt;
  &lt;div class=&quot;card&quot;&gt;
      &lt;div class=&quot;card-header&quot;&gt;
          Quote
      &lt;/div&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;blockquote class=&quot;blockquote mb-0 ps-3&quot;&gt;
              &lt;p&gt;Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.&lt;/p&gt;
              &lt;footer class=&quot;blockquote-footer&quot;&gt;Someone famous in &lt;cite title=&quot;Source Title&quot;&gt;Source Title&lt;/cite&gt;&lt;/footer&gt;
          &lt;/blockquote&gt;
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;!-- Card: 4 --&gt;
  &lt;div class=&quot;card&quot;&gt;
      &lt;div class=&quot;card-header&quot;&gt;
          Featured
      &lt;/div&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card-footer text-muted&quot;&gt;
          2 days ago
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;!-- Card: 5 --&gt;
  &lt;div class=&quot;card text-center border-primary&quot;&gt;
      &lt;div class=&quot;card-header&quot;&gt;
          Featured
      &lt;/div&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-secondary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card-footer bg-primary text-light&quot;&gt;
          2 days ago
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Text alignment</h5>
              <p>You can quickly change the text alignment of any card—in its entirety or specific parts—with our <a
                  href="https://getbootstrap.com/docs/4.5/utilities/text/#text-alignment">text align classes</a>.</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab5('1')"
                      [ngClass]="{'active': viewTab4}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab5('2')"
                      [ngClass]="{'active': codeTab4}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c5" [ngClass]="{'show active': viewTab4}">
                      <div class="row">
                        <div class="col-lg-4 col-md-12">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-dark">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12">
                          <div class="card text-center">
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-dark">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12">
                          <div class="card text-end">
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-dark">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-5" [ngClass]="{'show active': codeTab4}">
                      <pre><code class="language-html">&lt;div class=&quot;row&quot;&gt;
      &lt;div class=&quot;col-lg-4 col-md-12&quot;&gt;
          &lt;div class=&quot;card&quot;&gt;
              &lt;div class=&quot;card-body&quot;&gt;
                  &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
                  &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
                  &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;col-lg-4 col-md-12&quot;&gt;
          &lt;div class=&quot;card text-center&quot;&gt;
              &lt;div class=&quot;card-body&quot;&gt;
                  &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
                  &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
                  &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;col-lg-4 col-md-12&quot;&gt;
          &lt;div class=&quot;card text-end&quot;&gt;
              &lt;div class=&quot;card-body&quot;&gt;
                  &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
                  &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
                  &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Navigation</h5>
              <p>Add some navigation to a card’s header (or block) with Bootstrap’s <a
                  href="/docs/4.5/components/navs/">nav components</a>.</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab6('1')"
                      [ngClass]="{'active': viewTab5}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab6('2')"
                      [ngClass]="{'active': codeTab5}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c6" [ngClass]="{'show active': viewTab5}">
                      <div class="row">
                        <div class="col-lg-6 col-md-12">
                          <div class="card text-center">
                            <div class="card-header">
                              <ul class="nav nav-tabs card-header-tabs">
                                <li class="nav-item"><a class="nav-link active" href="#">Active</a></li>
                                <li class="nav-item"><a class="nav-link" href="#">Link</a></li>
                                <li class="nav-item"><a class="nav-link disabled" href="#" tabindex="-1"
                                    aria-disabled="true">Disabled</a></li>
                              </ul>
                            </div>
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-primary">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <div class="card text-center">
                            <div class="card-header">
                              <ul class="nav nav-pills card-header-pills">
                                <li class="nav-item"><a class="nav-link active" href="#">Active</a></li>
                                <li class="nav-item"><a class="nav-link" href="#">Link</a></li>
                                <li class="nav-item"><a class="nav-link disabled" href="#" tabindex="-1"
                                    aria-disabled="true">Disabled</a></li>
                              </ul>
                            </div>
                            <div class="card-body">
                              <h5 class="card-title">Special title treatment</h5>
                              <p class="card-text">With supporting text below as a natural lead-in to additional
                                content.
                              </p>
                              <a href="#" class="btn btn-primary">Go somewhere</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-6" [ngClass]="{'show active': codeTab5}">
                      <pre><code class="language-html">&lt;div class=&quot;card text-center&quot;&gt;
      &lt;div class=&quot;card-header&quot;&gt;
          &lt;ul class=&quot;nav nav-tabs card-header-tabs&quot;&gt;
              &lt;li class=&quot;nav-item&quot;&gt;&lt;a class=&quot;nav-link active&quot; href=&quot;#&quot;&gt;Active&lt;/a&gt;&lt;/li&gt;
              &lt;li class=&quot;nav-item&quot;&gt;&lt;a class=&quot;nav-link&quot; href=&quot;#&quot;&gt;Link&lt;/a&gt;&lt;/li&gt;
              &lt;li class=&quot;nav-item&quot;&gt;&lt;a class=&quot;nav-link disabled&quot; href=&quot;#&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Disabled&lt;/a&gt;&lt;/li&gt;
          &lt;/ul&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;div class=&quot;card text-center&quot;&gt;
      &lt;div class=&quot;card-header&quot;&gt;
          &lt;ul class=&quot;nav nav-pills card-header-pills&quot;&gt;
              &lt;li class=&quot;nav-item&quot;&gt;&lt;a class=&quot;nav-link active&quot; href=&quot;#&quot;&gt;Active&lt;/a&gt;&lt;/li&gt;
              &lt;li class=&quot;nav-item&quot;&gt;&lt;a class=&quot;nav-link&quot; href=&quot;#&quot;&gt;Link&lt;/a&gt;&lt;/li&gt;
              &lt;li class=&quot;nav-item&quot;&gt;&lt;a class=&quot;nav-link disabled&quot; href=&quot;#&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Disabled&lt;/a&gt;&lt;/li&gt;
          &lt;/ul&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card-body&quot;&gt;
          &lt;h5 class=&quot;card-title&quot;&gt;Special title treatment&lt;/h5&gt;
          &lt;p class=&quot;card-text&quot;&gt;With supporting text below as a natural lead-in to additional content.&lt;/p&gt;
          &lt;a href=&quot;#&quot; class=&quot;btn btn-primary&quot;&gt;Go somewhere&lt;/a&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Card groups</h5>
              <p>Use card groups to render cards as a single, attached element with equal width and height columns. Card
                groups start off stacked and use <code class="text-danger">display: flex;</code> to become attached with
                uniform dimensions starting at the <code class="text-danger">sm</code> breakpoint.
              </p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab7('1')"
                      [ngClass]="{'active': viewTab6}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab7('2')"
                      [ngClass]="{'active': codeTab6}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c7" [ngClass]="{'show active': viewTab6}">
                      <div class="card-group">
                        <div class="card">
                          <img src="assets/images/gallery/6.jpg" class="card-img-top" alt="...">
                          <div class="card-body">
                            <h5 class="card-title">Card title</h5>
                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to
                              additional content. This content is a little bit longer.
                            </p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                          </div>
                        </div>
                        <div class="card">
                          <img src="assets/images/gallery/7.jpg" class="card-img-top" alt="...">
                          <div class="card-body">
                            <h5 class="card-title">Card title</h5>
                            <p class="card-text">This card has supporting text below as a natural lead-in to additional
                              content.
                            </p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                          </div>
                        </div>
                        <div class="card">
                          <img src="assets/images/gallery/8.jpg" class="card-img-top" alt="...">
                          <div class="card-body">
                            <h5 class="card-title">Card title</h5>
                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to
                              additional content. This card has even longer content than the first to show that equal
                              height action.
                            </p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-7" [ngClass]="{'show active': codeTab6}">
                      <pre><code class="language-html">&lt;div class=&quot;card-group&quot;&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;img src=&quot;assets/images/gallery/6.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.&lt;/p&gt;
              &lt;p class=&quot;card-text&quot;&gt;&lt;small class=&quot;text-muted&quot;&gt;Last updated 3 mins ago&lt;/small&gt;&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;img src=&quot;assets/images/gallery/7.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This card has supporting text below as a natural lead-in to additional content.&lt;/p&gt;
              &lt;p class=&quot;card-text&quot;&gt;&lt;small class=&quot;text-muted&quot;&gt;Last updated 3 mins ago&lt;/small&gt;&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;img src=&quot;assets/images/gallery/8.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.&lt;/p&gt;
              &lt;p class=&quot;card-text&quot;&gt;&lt;small class=&quot;text-muted&quot;&gt;Last updated 3 mins ago&lt;/small&gt;&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Card columns</h5>
              <p>Cards can be organized into <a href="https://masonry.desandro.com/">Masonry</a>-like columns with just
                CSS by wrapping them in <code class="text-danger">.card-columns</code>. Cards are built with CSS <code
                  class="text-danger">column</code> properties instead of flexbox for easier alignment. Cards are
                ordered from top to bottom and left to right.
              </p>
              <p><strong>Heads up!</strong> Your mileage with card columns may vary. To prevent cards breaking across
                columns, we must set them to <code class="text-danger">display: inline-block</code> as <code
                  class="text-danger">column-break-inside: avoid</code> isn’t a bulletproof solution yet.
              </p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab8('1')"
                      [ngClass]="{'active': viewTab7}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab8('2')"
                      [ngClass]="{'active': codeTab7}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c8" [ngClass]="{'show active': viewTab7}">
                      <div class="card-columns">
                        <div class="card">
                          <img src="assets/images/gallery/10.jpg" class="card-img-top" alt="...">
                          <div class="card-body">
                            <h5 class="card-title">Card title that wraps to a new line</h5>
                            <p class="card-text">This is a longer card with supporting text below as a natural lead-in
                              to additional content. This content is a little bit longer.
                            </p>
                          </div>
                        </div>
                        <div class="card p-3">
                          <blockquote class="blockquote mb-0 card-body">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
                            <footer class="blockquote-footer">
                              <small class="text-muted">
                                Someone famous in <cite title="Source Title">Source Title</cite>
                              </small>
                            </footer>
                          </blockquote>
                        </div>
                        <div class="card">
                          <img src="assets/images/gallery/1.jpg" class="card-img-top" alt="...">
                          <div class="card-body">
                            <h5 class="card-title">Card title</h5>
                            <p class="card-text">This card has supporting text below as a natural lead-in to additional
                              content.
                            </p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                          </div>
                        </div>
                        <div class="card bg-primary text-center p-3">
                          <blockquote class="blockquote mb-0">
                            <p class="text-light">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                              posuere erat.
                            </p>
                            <footer class="blockquote-footer text-light">
                              <small>
                                Someone famous in <cite title="Source Title">Source Title</cite>
                              </small>
                            </footer>
                          </blockquote>
                        </div>
                        <div class="card text-center">
                          <div class="card-body">
                            <h5 class="card-title">Card title</h5>
                            <p class="card-text">This card has a regular title and short paragraphy of text below it.
                            </p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                          </div>
                        </div>
                        <div class="card">
                          <img src="assets/images/gallery/2.jpg" class="card-img-top" alt="...">
                        </div>
                        <div class="card p-3 text-end">
                          <blockquote class="blockquote mb-0">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
                            <footer class="blockquote-footer">
                              <small class="text-muted">
                                Someone famous in <cite title="Source Title">Source Title</cite>
                              </small>
                            </footer>
                          </blockquote>
                        </div>
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">Card title</h5>
                            <p class="card-text">This is another card with title and supporting text below. This card
                              has some additional content to make it slightly taller overall.
                            </p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-8" [ngClass]="{'show active': codeTab7}">
                      <pre><code class="language-html">&lt;div class=&quot;card-columns&quot;&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;img src=&quot;assets/images/gallery/10.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title that wraps to a new line&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card p-3&quot;&gt;
          &lt;blockquote class=&quot;blockquote mb-0 card-body&quot;&gt;
              &lt;p&gt;Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.&lt;/p&gt;
              &lt;footer class=&quot;blockquote-footer&quot;&gt;
                  &lt;small class=&quot;text-muted&quot;&gt;
                      Someone famous in &lt;cite title=&quot;Source Title&quot;&gt;Source Title&lt;/cite&gt;
                  &lt;/small&gt;
              &lt;/footer&gt;
          &lt;/blockquote&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;img src=&quot;assets/images/gallery/1.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This card has supporting text below as a natural lead-in to additional content.&lt;/p&gt;
              &lt;p class=&quot;card-text&quot;&gt;&lt;small class=&quot;text-muted&quot;&gt;Last updated 3 mins ago&lt;/small&gt;&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card bg-primary text-center p-3&quot;&gt;
          &lt;blockquote class=&quot;blockquote mb-0&quot;&gt;
              &lt;p class=&quot;text-light&quot;&gt;Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat.&lt;/p&gt;
              &lt;footer class=&quot;blockquote-footer text-light&quot;&gt;
                  &lt;small&gt;
                      Someone famous in &lt;cite title=&quot;Source Title&quot;&gt;Source Title&lt;/cite&gt;
                  &lt;/small&gt;
              &lt;/footer&gt;
          &lt;/blockquote&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card text-center&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This card has a regular title and short paragraphy of text below it.&lt;/p&gt;
              &lt;p class=&quot;card-text&quot;&gt;&lt;small class=&quot;text-muted&quot;&gt;Last updated 3 mins ago&lt;/small&gt;&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;img src=&quot;assets/images/gallery/2.jpg&quot; class=&quot;card-img-top&quot; alt=&quot;...&quot;&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card p-3 text-end&quot;&gt;
          &lt;blockquote class=&quot;blockquote mb-0&quot;&gt;
              &lt;p&gt;Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.&lt;/p&gt;
              &lt;footer class=&quot;blockquote-footer&quot;&gt;
                  &lt;small class=&quot;text-muted&quot;&gt;
                      Someone famous in &lt;cite title=&quot;Source Title&quot;&gt;Source Title&lt;/cite&gt;
                  &lt;/small&gt;
              &lt;/footer&gt;
          &lt;/blockquote&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;div class=&quot;card-body&quot;&gt;
              &lt;h5 class=&quot;card-title&quot;&gt;Card title&lt;/h5&gt;
              &lt;p class=&quot;card-text&quot;&gt;This is another card with title and supporting text below. This card has some additional content to make it slightly taller overall.&lt;/p&gt;
              &lt;p class=&quot;card-text&quot;&gt;&lt;small class=&quot;text-muted&quot;&gt;Last updated 3 mins ago&lt;/small&gt;&lt;/p&gt;
          &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Page Default -->
    </div>
    <!-- End chat body -->
  </div>
  <!-- Main Body: Content -->
</div>
